import React from "react";
import { Layout } from "../layout/Layout.js";
import { CloudProvider } from "./CloudProvider.js";
import { CloudEntriesList } from "./CloudEntriesList.js";
import { CloudForm } from "./CloudForm.js";
import { CloudTitle } from "./CloudTitle.js";

/**
 * Renders cloud with list of files and upload button.
 */
export const CloudPage = () => {
  return (
    <Layout title="Cloud">
      <CloudProvider>
        <CloudTitle />
        <CloudEntriesList />
        <CloudForm />
      </CloudProvider>
    </Layout>
  );
};
